import { render, staticRenderFns } from "./NotificationsData.vue?vue&type=template&id=750ddc15&"
import script from "./NotificationsData.vue?vue&type=script&lang=js&"
export * from "./NotificationsData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports